import React, { useEffect } from 'react';
import icons from '../../assets';
import { BigButton } from '../../common';
import { useNavigate } from 'react-router-dom';
import styles from './UpgradeForMore.module.scss';
import useCurrentOrganizationInfo from '../../hooks/useCurrentOrganizationInfo';
import { openFormInCaseOfNewOrgAndFreemiumUser } from '../../helpers/jsHelper';
const { CrossIcon } = icons;

function ModelLimitUpgrade({ onClose, className, limit }) {
  const navigate = useNavigate();
  const { hideNewPlans, isFreemiumUser } = useCurrentOrganizationInfo();

  useEffect(() => {
    if (hideNewPlans || isFreemiumUser) { // open enterprise form in case of freemium user whose org is created after 10th Feb 2025
      openFormInCaseOfNewOrgAndFreemiumUser();
      onClose?.();
    }
  }, [hideNewPlans,isFreemiumUser]);

  const handleButtonClick = () => {
    const url = `/my-plans/`;
    navigate(url);
    onClose();
  };

  const countText = () => {
    if (!limit?.models && !limit?.textures) return '';
    let text = '';
    if (limit?.models) {
      text = `${limit?.models} model`;
      if (limit?.models > 1) text += 's';
    }
    if (limit?.models && limit?.textures) text += ' and ';
    if (limit?.textures) {
      text += `${limit?.textures} texture`;
      if (limit?.textures > 1) text += 's';
    }
    return `Successfully uploaded ${text} as per your current limit. `;
  };

  const limitExceededForText = () => {
    let text = '';
    if (limit?.models !== undefined) {
      text = 'models';
    }
    if (limit?.models !== undefined && limit?.textures !== undefined) text += ' and ';
    if (limit?.textures !== undefined) {
      text += 'textures';
    }
    return text;
  };

  if (hideNewPlans || isFreemiumUser) { // hide this in case of freemium user whose org is created after 10th Feb 2025
    return null;
  }

  return (
    <div className={className}>
      <span>{`${countText()}Upgrade limit to upload more ${limitExceededForText()}.`}</span>
      <div className="d-flex gap-3 align-items-center">
        <BigButton onClick={handleButtonClick} className={styles.button} style={{ width: '125px' }}>
          Upgrade plan
        </BigButton>
        <CrossIcon className={styles.closeIconLimitPopup} onClick={onClose} />
      </div>
    </div>
  );
}

export default ModelLimitUpgrade;
